import PerfilesForm from "./PerfilesForm";
export default PerfilesForm;